import { LDFlagSet, useFlags } from "launchdarkly-react-client-sdk";

interface IFeatureFlags {
  children: (flags: LDFlagSet) => React.ReactNode;
}

export const FeatureFlags = (props: IFeatureFlags) => {
  const flags = useFlags();
  return props.children(flags);
};
